import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "23",
  height: "24",
  viewBox: "0 0 23 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M22.8164 12.0235C22.8164 11.2123 22.7436 10.4324 22.6084 9.68359H11.8345V14.1086H17.991C17.7258 15.5385 16.9199 16.7501 15.7083 17.5613V20.4315H19.4053C21.5685 18.44 22.8164 15.5073 22.8164 12.0235Z",
  fill: "#4285F4"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M11.8346 23.2025C14.9232 23.2025 17.5127 22.1782 19.4055 20.431L15.7084 17.5608C14.6841 18.2471 13.3737 18.6527 11.8346 18.6527C8.85511 18.6527 6.33321 16.6404 5.43365 13.9365H1.61182V16.9004C3.49414 20.639 7.36277 23.2025 11.8346 23.2025Z",
  fill: "#34A853"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M5.4336 13.9378C5.20481 13.2515 5.07482 12.5183 5.07482 11.7643C5.07482 11.0104 5.20481 10.2772 5.4336 9.59083V6.62695H1.61177C0.837001 8.17129 0.39502 9.91841 0.39502 11.7643C0.39502 13.6103 0.837001 15.3574 1.61177 16.9017L5.4336 13.9378Z",
  fill: "#FBBC05"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M11.8346 4.87402C13.5141 4.87402 15.022 5.4512 16.2076 6.58475L19.4886 3.30369C17.5075 1.45777 14.918 0.324219 11.8346 0.324219C7.36277 0.324219 3.49414 2.88771 1.61182 6.62635L5.43365 9.59022C6.33321 6.88634 8.85511 4.87402 11.8346 4.87402Z",
  fill: "#EA4335"
}, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_6))
}